<template>
  <div :class="['centered-vertical', {container:container}]" :vertical="vertical">
    <div :class="['centered-horizontal', {container:container}]" :horizontal="horizontal">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "centered-container",
  props: {
    horizontal: {
      type: String,
      default: "center",
    },
    vertical: {
      type: String,
      default: "center",
    },
    container: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.centered-vertical {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;

  &[vertical="center"] {
    justify-content: center;
  }

  &[vertical="top"] {
    justify-content: left;
  }

  &[vertical="bottom"] {
    justify-content: right;
  }
}

.centered-horizontal {
  display: flex;

  &[horizontal="left"] {
    justify-content: flex-start;
  }

  &[horizontal="right"] {
    justify-content: flex-end;
  }

  &[horizontal="center"] {
    justify-content: center;
  }
}
</style>
